export const FEATURE_DEPOSIT_WIDGET = "DepositWidget"; //used only on backend side
export const FEATURE_CASHOUT_WIDGET = "CashoutWidget"; //used only on backend side
export const FEATURE_TRANSACTION_HISTORY_WIDGET = "TransactionHistoryWidget";
export const FEATURE_NAME_REGISTRATION_WIDGET = "RegistrationWidget";
export const FEATURE_NAME_CONTROL_CENTER_TOGGLE = "AbTestingSafeZoneToggle";
export const FEATURE_NAME_ONBOARDING_TOUR = "OnboardingTourActivated";
export const FEATURE_NAME_VIDEO_LIVE_STREAM = "LiveStreamEnabled";
export const FEATURE_NAME_STATIC_VIDEO_LIST = "StaticVideoListEnabled";
export const FEATURE_NAME_VIDEO_SLIDES = "OrbitExplorer";
export const FEATURE_NAME_MOBILE_HEADER_SEARCH_BUTTON = "MobileHeaderSearchButton";
export const FEATURE_NAME_WEBAPP_BOTTOM_NAVIGATION = "WebappBottomNavigation";
export const FEATURE_NAME_AI_SORT_GAME_LIST = "AbTestingAiSortGamesLists";
export const FEATURE_NAME_PLAYERS_LIKE_YOU_GAMES_LIST_TYPE_ID = "PlayersLikeYouGamesListTypeId";
export const FEATURE_NAME_SEARCH_GAME_SUGGESTED_BY_AI = "SearchGameSuggestionByAI";
export const FEATURE_NAME_LIST_ON_TOP = "ListOnTop";



export const FEATURE_GAME_RECOMMENDATIONS = 'GameRecommendations';
export const FEATURE_ROUTE_OVERWRITE = "AbRouteOverwrite";
export const FEATURE_NAME_BECAUSE_YOU_PLAYED_LIST = "BecauseYouPlayedListEnabled";


export const FEATURE_NAME_FREE_TO_PLAY_FLOW = "FreeToPlayFlow";

export const FEATURE_NAME_STATIC_LIVE_ARENA = "StaticLiveArena";

export const FEATURE_NAME_ADD_IN_GAME_FUNDS = "AddInGameFunds";

export const FEATURE_NAME_JACKPOT_BET = "JackpotBet";

export const FEATURE_NAME_TABS_NAVIGATION = "TabsNavigation";

export const FEATURE_NAME_HOMEPAGE_ARENAS_HIDE = "HomepageArenasHide";

